const validationScrollMixin = {
  methods: {
    showAlertAndScrollToFirstError() {
      this.$store.dispatch('alert', {
        text: 'There are some errors with the data you entered. Please review and try again.',
        color: 'error',
        multiline: true
      })

      setTimeout(() => {
        this.$vuetify.goTo('.error--text', { container: '.v-dialog.v-dialog--active .v-card__text' })
      }, 100)
    }
  }
}

export default validationScrollMixin
